class Controller {
  constructor() {
    "ngInject";
  }
}

export default Controller;
